import React from 'react';
import './ModalPage.scss';

export default function Modal({ children, title, details, style,  ...rest })
{
    return (
        <div className='modal-page' style={style}>
            <div className='modal-page--content'>
                {
                    title ? (
                        <div className='modal-page--content--title'>
                            <h3>{title}</h3>
                        </div>
                    ): null
                }
                <div className='modal-page--content--body'>
                    {children}
                </div>
                
            </div>
        </div>
    )
}